import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContentPageComponent } from './components/content-page/content-page.component';

const routes: Routes = [
    {
        path: '**',
        component: ContentPageComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
    exports: [RouterModule]
})
export class ContentRoutingModule {
}
